<template>
  <TitleWrapper
    :filter-option="true"
    title="DAILY_STUDENT_ATTENDANCE"
    tooltip-title="DAILY_STUDENT_ATTENDANCE"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiMultiSelect
          v-model.trim="filtersPayload.user_id"
          title="STUDENTS"
          :options="studentList"
          reduce="id"
          label="full_name"
          input-color="bg-white"
          :already-selected="selectedStudent"
          :search-through-api="true"
          :filter="FILTERS_LIST.MULTIPLE_USERS"
          @search="getStudents"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.status"
          title="STATUS"
          :options="attendanceStatusOptions"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.STATUS"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import { TENANT_ROLES } from '@/src/constants/user-roles-constants'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import { getCountFromObject, pluralToSingular } from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { mapActions, mapState } from 'vuex'
import filterMixins from '@/src/mixins/filter-mixins.js'
import { buildWhereQuery } from '@/src/utils/filters'
import { ATTENDANCE_STATUSES } from '@src/constants/attandance/attandance-constant.js'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiMultiSelect,
    UiSingleSelect,
    TitleWrapper,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ATTENDANCE_STATUSES,
      FILTER_KEYS,
      studentList: [],
      $where: {},
      selectedStudent: [],
      FILTERS_LIST,
      filtersPayload: {
        status: '',
        user_id: [],
        displayedColumns: [],
      },
      filtersCount: 0,
    }
  },

  computed: {
    attendanceStatusOptions() {
      return [...this.ATTENDANCE_STATUSES, { title: 'Tardy', value: 'tardy' }]
    },

    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope.id,
      activeRole: (state) => state.layout.activeRole,
    }),
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getStudents()
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.getStudents()
  },
  methods: {
    pluralToSingular,
    getStudents(query) {
      if (this.activeRole === TENANT_ROLES.SECTION_STUDENT) return
      let alreadyselectedStudent = []
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query),
        },
      }
      this.getStudentsWithFilters(payload).then((res) => {
        this.studentList = res?.records
        this.studentList?.forEach((record) => {
          if (this.filtersPayload && this.filtersPayload.user_id.length) {
            this.filtersPayload.user_id.forEach((id) => {
              if (record.id === id) {
                alreadyselectedStudent.push(record)
              }
            })
          }
          this.selectedStudent = alreadyselectedStudent
        })
      })
    },
    getFiltersCount() {
      this.getStudents()
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    ...mapActions('student', ['getStudentsWithFilters']),
  },
}
</script>
